import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Default } from "../layouts/default";
import "../../css/homepage.css";
import {
  Link,
  useLoaderData,
  useNavigate,
  useLocation,
} from "react-router-dom";
import axios from "axios";
import SearchLocation from "../common/searchLocation";
import LazyImage from "../common/LazyImage";

import iconCricket from "../../image/1.png";
import iconShuttle from "../../image/2.png";
import iconBasket from "../../image/3.png";
import iconTennis from "../../image/4.png";
import iconBats from "../../image/5.png";
import iconPool from "../../image/6.png";
import iconVolleyball from "../../image/7.png";
import iconFootball from "../../image/8.png";
import iconHotel from "../../image/10.png";
import iconSnooker from "../../image/iconSnooker.png";
import iconCourt from "../../image/iconCourt.png";
import iconPickleball from "../../image/pickleball.png";
import iconGym from "../../image/gym.png";
import iconbilliards from "../../image/shuttle.png";

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
const IMG_URL = process.env.REACT_APP_IMG_URL;

/* ---- Fallback hero cards if no featured facility data ---- */
const FALLBACK_HERO_CARDS = [
  {
    cat: "Tennis",
    name: "Tennis Court",
    price: "₹ 599 /hr",
    tone: "tennis",
    img: "https://images.unsplash.com/photo-1622279457486-62dcc4a431d6?w=600&q=85&auto=format&fit=crop",
    icon: "fa-solid fa-baseball",
  },
  {
    cat: "Court",
    name: "Indoor Basketball",
    price: "₹ 499 /hr",
    tone: "basketball",
    img: "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=700&q=85&auto=format&fit=crop",
    icon: "fa-solid fa-basketball",
  },
  {
    cat: "Turf",
    name: "Premium Football",
    price: "₹ 799 /hr",
    tone: "football",
    img: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=900&q=85&auto=format&fit=crop",
    icon: "fa-solid fa-futbol",
  },
  {
    cat: "Cricket",
    name: "Cricket Ground",
    price: "₹ 699 /hr",
    tone: "cricket",
    img: "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=700&q=85&auto=format&fit=crop",
    icon: "fa-solid fa-baseball-bat-ball",
  },
  {
    cat: "Badminton",
    name: "Badminton Court",
    price: "₹ 399 /hr",
    tone: "badminton",
    img: "https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600&q=85&auto=format&fit=crop",
    icon: "fa-solid fa-table-tennis-paddle-ball",
  },
];

const QUICK_CHIPS = [
  { label: "Hotels", img: iconHotel },
  // { label: "Turfs", img: iconFootball },
  // { label: "Grounds", img: iconCricket },
  // { label: "Snooker", img: iconSnooker },
  // { label: "Badminton", img: iconbilliards },
  { label: "Courts", img: iconCourt },
  // { label: "Pickleball", img: iconPickleball },
  { label: "Fitness", img: iconGym },
  { label: "More", img: iconPool },
];

const TOP_DESTINATIONS = [
  { name: "Rajpur Road, Dehradun", venues: "12 venues" },
  { name: "Ballupur, Dehradun", venues: "8 venues" },
  { name: "Clement Town, Dehradun", venues: "6 venues" },
  { name: "Sahastradhara, Dehradun", venues: "5 venues" },
];

const BACK_TOP_RING_R = 22;
const BACK_TOP_RING_C = 2 * Math.PI * BACK_TOP_RING_R;

const HERO_TONES = ["tennis", "basketball", "football", "cricket", "badminton"];
const HERO_ICONS = [
  "fa-solid fa-baseball",
  "fa-solid fa-basketball",
  "fa-solid fa-futbol",
  "fa-solid fa-baseball-bat-ball",
  "fa-solid fa-table-tennis-paddle-ball",
];

const SPORT_TONE_ICONS = [
  "fa-solid fa-trophy",
  "fa-solid fa-baseball-bat-ball",
  "fa-solid fa-baseball",
  "fa-solid fa-futbol",
];

const SPORT_IMG_BY_NAME = (raw) => {
  const n = (raw || "").toLowerCase();
  if (/foot|soccer|turf/.test(n)) return iconFootball;
  if (/cricket|bat/.test(n)) return iconCricket;
  if (/badm|shuttle|racquet|racket/.test(n)) return iconShuttle;
  if (/basket/.test(n)) return iconBasket;
  if (/tennis/.test(n)) return iconTennis;
  if (/volley/.test(n)) return iconVolleyball;
  if (/pool|swim|table/.test(n)) return iconPool;
  if (/baseball/.test(n)) return iconBats;
  return iconFootball;
};

const PARSE_GALLERY = (facility, IMG_URL_PARAM) => {
  if (!facility) return [];
  const out = [];
  if (facility.featured_image) {
    out.push(
      `${IMG_URL_PARAM}${String(facility.featured_image).replace(/\\/g, "/")}`,
    );
  }
  try {
    const raw = facility.images;
    let parsed = [];
    if (typeof raw === "string" && raw.trim()) {
      parsed = JSON.parse(raw);
    } else if (Array.isArray(raw)) {
      parsed = raw;
    }
    if (Array.isArray(parsed)) {
      parsed.forEach((p) => {
        if (typeof p === "string") {
          out.push(`${IMG_URL_PARAM}${p.replace(/\\/g, "/")}`);
        } else if (p && typeof p === "object") {
          const path = p.image || p.url || p.path || p.featured_image;
          if (path)
            out.push(`${IMG_URL_PARAM}${String(path).replace(/\\/g, "/")}`);
        }
      });
    }
  } catch (e) {
    if (typeof console !== "undefined") {
      console.warn("Gallery parse failed:", e?.message || e);
    }
  }
  return Array.from(new Set(out));
};

const Homepage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { allServices } = useLoaderData() || {};

  const [allFacilities, setAllFacilities] = useState([]);
  const [allfeatured, setAllFeatured] = useState([]);
  const [allHotels, setAllHotels] = useState([]);
  const [hotelsLoading, setHotelsLoading] = useState(true);
  const [activeHotel, setActiveHotel] = useState(0);
  const [activeHotelImage, setActiveHotelImage] = useState(0);

  const [openIndex, setOpenIndex] = useState(1);

  /* Search panel focus */
  const [searchFocused, setSearchFocused] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [placeSuggestions, setPlaceSuggestions] = useState([]);
  const searchRef = useRef(null);
  const searchLocationRef = useRef(null);

  /* Featured facilities — active hero index + gallery image index */
  const [activeFeat, setActiveFeat] = useState(0);
  const [activeGallery, setActiveGallery] = useState(0);

  /* Reset gallery when facility changes */
  useEffect(() => {
    setActiveGallery(0);
  }, [activeFeat]);

  /* Back-to-top — right sticky FAB */
  const [showBackTop, setShowBackTop] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const maxScroll =
        document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress(
        maxScroll > 0 ? Math.min(100, (scrollY / maxScroll) * 100) : 0,
      );
      setShowBackTop(scrollY > 420);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ---- Click-outside handler for search panel ---- */
  useEffect(() => {
    const onClick = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setSearchFocused(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  /* ---- Scroll-reveal observer ---- */
  useEffect(() => {
    const els = document.querySelectorAll(".bv-reveal:not(.is-revealed)");
    if (!("IntersectionObserver" in window) || els.length === 0) {
      els.forEach((el) => el.classList.add("is-revealed"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -50px 0px" },
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [allfeatured, allFacilities]);

  /* ---- Data fetchers ---- */
  useEffect(() => {
    if (location.state) {
      const { lat, lng } = location.state;
      getFacilities({ lat, lng });
    } else {
      checkLocationPermission();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  const getFacilities = async (payLoad) => {
    try {
      const r = await axios.post(`${BASE_URL}/searchLocation`, payLoad);
      setAllFacilities(r.data.facility);
    } catch (e) {
      console.error("Error fetching facilities by location:", e);
    }
  };

  const checkLocationPermission = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) =>
          getInitialData({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          }),
        () => getInitialData(),
      );
    } else getInitialData();
  };

  const getInitialData = async (coords) => {
    try {
      const req = coords
        ? axios.get(`${BASE_URL}/get-all-facility`, { params: coords })
        : axios.get(`${BASE_URL}/get-all-facility`);
      const res = await req;
      setAllFacilities(res.data.facility);
    } catch (e) {
      console.error("Error fetching initial facilities:", e);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${BASE_URL}/get-featured-facility`);
        setAllFeatured(res.data);
      } catch (e) {
        console.error("Error fetching featured facilities:", e);
      }
    })();
  }, []);

  /* ---- Helpers ---- */
  const stripHtml = (t) => (t ? t.replace(/<[^>]+>/g, "") : "");
  const toggleAccordion = (i) => setOpenIndex((p) => (p === i ? null : i));

  const useCurrentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) =>
          navigate("/all-facilities", {
            state: { lat: pos.coords.latitude, lng: pos.coords.longitude },
          }),
        () => navigate("/all-facilities"),
      );
    } else {
      navigate("/all-facilities");
    }
    setSearchFocused(false);
  };

  const showPlaceSuggestions =
    searchQuery.length > 1 && placeSuggestions.length > 0;

  /* ---- Hero cards from real featured data ---- */
  const heroSource = Array.isArray(allfeatured?.facility)
    ? allfeatured.facility
    : [];
  const heroCards =
    heroSource.length >= 1
      ? heroSource.slice(0, 5).map((f, i) => {
          const imgRaw = f?.featured_image
            ? f.featured_image.replace(/\\\//g, "/")
            : null;
          const fullImg = imgRaw
            ? `${IMG_URL}${imgRaw}`
            : FALLBACK_HERO_CARDS[i]?.img;
          const cat =
            f?.services?.[0]?.name || FALLBACK_HERO_CARDS[i]?.cat || "Sport";
          return {
            slug: f?.slug,
            name: f?.official_name || FALLBACK_HERO_CARDS[i]?.name,
            cat,
            price: f?.minPrice
              ? `₹ ${f.minPrice} /hr`
              : FALLBACK_HERO_CARDS[i]?.price || "Book now",
            img: fullImg,
            tone: HERO_TONES[i % HERO_TONES.length],
            icon: HERO_ICONS[i % HERO_ICONS.length],
          };
        })
      : FALLBACK_HERO_CARDS;
  while (heroCards.length < 5)
    heroCards.push(FALLBACK_HERO_CARDS[heroCards.length]);

  const featuredList = heroSource.length > 0 ? heroSource : [];
  const heroFacility = featuredList[activeFeat] || featuredList[0];

  /* Fixed mini-cards on the right — always the first 3 of featuredList.
     They DO NOT get filtered out when active; clicking one just opens it in
     the big card. The currently-active one is highlighted via .is-active.   */
  const sideCards = featuredList.slice(0, 5);

  const safeImg = (f, fb) => {
    const imgRaw = f?.featured_image
      ? f.featured_image.replace(/\\\//g, "/")
      : null;
    return imgRaw ? `${IMG_URL}${imgRaw}` : fb;
  };

  const heroGallery = PARSE_GALLERY(heroFacility, IMG_URL).slice(0, 5);

  const cycleFeat = (dir) => {
    if (featuredList.length === 0) return;
    setActiveFeat((p) => {
      const len = featuredList.length;
      return (p + dir + len) % len;
    });
  };
  useEffect(() => {
    const controller = new AbortController();

    const getHotels = async () => {
      try {
        setHotelsLoading(true);

        const response = await fetch(
          "https://admin.bookvenue.app/api/hotels?per_page=5&page=1",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
            signal: controller.signal,
          },
        );

        if (!response.ok) {
          throw new Error(`Unable to load hotels (${response.status})`);
        }

        const result = await response.json();

        const hotelData = Array.isArray(result?.data)
          ? result.data
          : Array.isArray(result?.data?.data)
            ? result.data.data
            : [];

        setAllHotels(hotelData);
      } catch (error) {
        if (error?.name !== "AbortError") {
          console.error("Error fetching hotels:", error);
          setAllHotels([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setHotelsLoading(false);
        }
      }
    };

    getHotels();

    return () => controller.abort();
  }, []);

  const getHotelImage = (hotel) =>
    hotel?.cover_image ||
    hotel?.image ||
    hotel?.image_url ||
    hotel?.thumbnail ||
    "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=85&auto=format&fit=crop";

  const getHotelSlug = (hotel) => hotel?.slug || hotel?.id || "";

  const getHotelPrice = (hotel) => {
    const price =
      hotel?.price ??
      hotel?.starting_price ??
      hotel?.startingPrice ??
      hotel?.price_per_night ??
      hotel?.pricePerNight;

    if (price === null || price === undefined || price === "") {
      return null;
    }

    const numericPrice = Number(String(price).replace(/[^0-9.]/g, ""));

    return Number.isFinite(numericPrice) ? numericPrice : null;
  };

  const getHotelRating = (hotel) => {
    const rating =
      typeof hotel?.rating === "object"
        ? hotel?.rating?.average
        : (hotel?.rating ?? hotel?.average_rating ?? hotel?.averageRating);

    if (rating === null || rating === undefined || rating === "") {
      return null;
    }

    const numericRating = Number(rating);

    return Number.isFinite(numericRating) ? numericRating : null;
  };

  const getHotelTags = (hotel) => {
    if (Array.isArray(hotel?.tags)) {
      return hotel.tags;
    }

    if (typeof hotel?.tags === "string") {
      return hotel.tags
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);
    }

    return [];
  };

  const getHotelGallery = (hotel) => {
    if (!hotel) return [];

    const images = [];

    // Cover image
    if (hotel.cover_image) {
      images.push(hotel.cover_image);
    }

    // Other possible image fields
    const raw = hotel.images;

    try {
      let parsed = [];

      if (typeof raw === "string" && raw.trim()) {
        parsed = JSON.parse(raw);
      } else if (Array.isArray(raw)) {
        parsed = raw;
      }

      if (Array.isArray(parsed)) {
        parsed.forEach((item) => {
          if (typeof item === "string") {
            images.push(item);
          } else if (item && typeof item === "object") {
            const image =
              item.image ||
              item.url ||
              item.path ||
              item.featured_image ||
              item.cover_image;

            if (image) {
              images.push(image);
            }
          }
        });
      }
    } catch (error) {
      console.warn("Hotel gallery parse failed:", error);
    }

    return [...new Set(images)].filter(Boolean);
  };

  const hotelHeroCards = allHotels.slice(0, 5).map((hotel, i) => {
    const price = getHotelPrice(hotel);
    const rating = getHotelRating(hotel);

    return {
      slug: getHotelSlug(hotel),
      name:
        hotel?.name || hotel?.hotel_name || hotel?.title || `Hotel ${i + 1}`,
      cat: rating ? `Hotel · ${rating.toFixed(1)} ★` : "Hotel",
      price: price ? `₹ ${price} /night` : "Book now",
      img: getHotelImage(hotel),
      tone: "hotel",
      icon: "fa-solid fa-hotel",
      type: "hotel",
    };
  });

  const combinedHeroCards = [
    ...heroCards.slice(0, 5).map((card) => ({
      ...card,
      type: "facility",
    })),
    ...hotelHeroCards,
  ];

  const [heroSlideIndex, setHeroSlideIndex] = useState(0);

  /* Auto slide — one card at a time */
  useEffect(() => {
    if (combinedHeroCards.length <= 5) return;

    const interval = setInterval(() => {
      setHeroSlideIndex((prev) => {
        return (prev + 1) % combinedHeroCards.length;
      });
    }, 3500);

    return () => clearInterval(interval);
  }, [combinedHeroCards.length]);

  /* Always show exactly 5 cards */
  const visibleHeroCards = Array.from({ length: 5 }, (_, i) => {
    return combinedHeroCards[(heroSlideIndex + i) % combinedHeroCards.length];
  });
  useEffect(() => {
    setActiveHotel(0);
    setActiveHotelImage(0);
  }, [allHotels]);
  useEffect(() => {
    setActiveHotelImage(0);
  }, [activeHotel]);

  return (
    <>
      <Helmet>
        <title>
          Book Sports Venue Online in India | Turf & Ground Booking | BookVenue
        </title>
        <meta
          name="description"
          content="Find and book sports venues near you, including cricket grounds, football turfs, and badminton courts. Easy and fast online booking with BookVenue."
        />
      </Helmet>

      <Default>
        <button
          type="button"
          className={`bv-back-top ${showBackTop ? "is-visible" : ""}`}
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <span className="bv-back-top__ring" aria-hidden="true">
            <svg viewBox="0 0 52 52" focusable="false">
              <defs>
                <linearGradient
                  id="bvBackTopGrad"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#14b8a6" />
                  <stop offset="100%" stopColor="#0d9488" />
                </linearGradient>
              </defs>
              <circle
                className="bv-back-top__ring-track"
                cx="26"
                cy="26"
                r={BACK_TOP_RING_R}
              />
              <circle
                className="bv-back-top__ring-fill"
                cx="26"
                cy="26"
                r={BACK_TOP_RING_R}
                strokeDasharray={BACK_TOP_RING_C}
                strokeDashoffset={BACK_TOP_RING_C * (1 - scrollProgress / 100)}
              />
            </svg>
          </span>
          <span className="bv-back-top__icon" aria-hidden="true">
            <i className="fa-solid fa-arrow-up"></i>
          </span>
        </button>

        <a
          href="https://wa.me/917500872014"
          target="_blank"
          rel="noopener noreferrer"
          className="bv-wa-chat"
          aria-label="Chat with us on WhatsApp"
        >
          <span className="bv-wa-chat__pulse" aria-hidden="true" />
          <span className="bv-wa-chat__icon" aria-hidden="true">
            <i className="fa-brands fa-whatsapp" />
          </span>
          <span className="bv-wa-chat__label">Chat</span>
        </a>

        {/* ============== HERO BANNER ============== */}
        <section className="bv-hero">
          <div className="bv-hero__inner">
            <div
              className="bv-hero__deco bv-hero__deco--soccer"
              aria-hidden="true"
            >
              <LazyImage src={iconFootball} alt="" loading="eager" />
            </div>
            <div
              className="bv-hero__deco bv-hero__deco--hotel"
              aria-hidden="true"
            >
              <LazyImage src={iconHotel} alt="" loading="eager" />
            </div>
            <div
              className="bv-hero__deco bv-hero__deco--shuttle"
              aria-hidden="true"
            >
              <LazyImage src={iconShuttle} alt="" loading="eager" />
            </div>

            <div className="bv-hero__grid">
              <div className="bv-hero__copy">
                <span className="bv-hero__eyebrow">
                  <i className="fa-solid fa-location-dot"></i>
                  Book Anytime, Anywhere
                </span>

                <h1 className="bv-hero__title">
                  <span className="bv-hero__title-line">Stay. Play.</span>
                  <span className="bv-hero__title-line bv-hero__title-line--teal">
                    Explore.
                  </span>
                  <span className="bv-hero__title-line bv-hero__title-line--script">
                    Book It All.
                  </span>
                </h1>

                <p className="bv-hero__lede">
                  Find and book hotels, resorts, sports venues, turfs, and
                  courts with BookVenue.
                </p>

                {/* Search w/ focus-panel */}
                <div
                  ref={searchRef}
                  className={`bv-hero__search-wrap ${searchFocused ? "is-focused" : ""}`}
                >
                  <div
                    className="bv-hero__search"
                    onFocusCapture={() => setSearchFocused(true)}
                  >
                    <span className="bv-hero__search-pin" aria-hidden="true">
                      <i className="fa-solid fa-location-dot"></i>
                    </span>
                    <div className="bv-hero__search-input">
                      <SearchLocation
                        ref={searchLocationRef}
                        panelMode
                        onQueryChange={setSearchQuery}
                        onSuggestionsChange={setPlaceSuggestions}
                        onPlaceSelect={() => setSearchFocused(false)}
                      />
                    </div>
                    <button
                      type="button"
                      className="bv-hero__search-btn"
                      aria-label="Search"
                    >
                      <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                  </div>

                  {searchFocused && (
                    <div className="bv-hero__search-panel">
                      {showPlaceSuggestions ? (
                        <>
                          <div className="bv-hero__search-sub">Suggestions</div>
                          <ul className="bv-hero__search-list">
                            {placeSuggestions.map((suggestion) => (
                              <li key={suggestion.place_id}>
                                <button
                                  type="button"
                                  onClick={() =>
                                    searchLocationRef.current?.selectPlace(
                                      suggestion,
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-location-dot"></i>
                                  <span>{suggestion.description}</span>
                                </button>
                              </li>
                            ))}
                          </ul>
                        </>
                      ) : (
                        <>
                          <button
                            type="button"
                            className="bv-hero__search-cta"
                            onClick={useCurrentLocation}
                          >
                            <i className="fa-solid fa-paper-plane"></i>
                            <span>Use current location</span>
                          </button>
                          <div className="bv-hero__search-sub">
                            Top destinations
                          </div>
                          <ul className="bv-hero__search-list">
                            {TOP_DESTINATIONS.map((d) => (
                              <li key={d.name}>
                                <button
                                  type="button"
                                  onClick={() => {
                                    navigate("/all-facilities");
                                    setSearchFocused(false);
                                  }}
                                >
                                  <i className="fa-solid fa-location-dot"></i>
                                  <span>{d.name}</span>
                                  <em>({d.venues})</em>
                                </button>
                              </li>
                            ))}
                          </ul>
                        </>
                      )}
                    </div>
                  )}
                </div>

                <div className="bv-hero__chips">
                  {QUICK_CHIPS.map((c) => (
                    <button
                      key={c.label}
                      type="button"
                      className="bv-hero__chip"
                      onClick={() => navigate("/all-facilities")}
                    >
                      <span className="bv-hero__chip-icon">
                        <LazyImage src={c.img} alt="" loading="eager" />
                      </span>
                      <span>{c.label}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Right-side card stage */}
              <div className="bv-hero__showcase">
                <div className="bv-stage">
                  {visibleHeroCards.map((card, i) => {
                    const clickable = !!card.slug;
                    const Tag = clickable ? "button" : "div";

                    return (
                      <Tag
                        key={`${card.type}-${card.slug || card.name}-${heroSlideIndex}-${i}`}
                        type={clickable ? "button" : undefined}
                        className={`bv-stage__card bv-stage__card--${i + 1}`}
                        onClick={
                          clickable
                            ? () => {
                                if (card.type === "hotel") {
                                  navigate(`/hotel/${card.slug}`);
                                } else {
                                  navigate(`/facility/${card.slug}`);
                                }
                              }
                            : undefined
                        }
                        aria-label={clickable ? `View ${card.name}` : undefined}
                      >
                        <div
                          className="bv-stage__photo"
                          style={{
                            backgroundImage: `url('${card.img}')`,
                          }}
                        />

                        <div className="bv-stage__tag">
                          <span
                            className={`bv-stage__tag-icon bv-stage__tag-icon--${card.tone}`}
                          >
                            <i className={card.icon}></i>
                          </span>

                          <div className="bv-stage__tag-text">
                            <span className="bv-stage__tag-cat">
                              {card.cat}
                            </span>

                            <span className="bv-stage__tag-name">
                              {card.name}
                            </span>

                            <span className="bv-stage__tag-price">
                              From {card.price}
                            </span>
                          </div>
                        </div>
                      </Tag>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Hero bottom strip — refined */}
            <div className="bv-hero__strip">
              <div className="bv-app-pill">
                <span className="bv-app-pill__icon" aria-hidden="true">
                  <i className="fa-solid fa-mobile-screen-button"></i>
                  <span className="bv-app-pill__dot"></span>
                </span>
                <div className="bv-app-pill__text">
                  <strong>Get the App</strong>
                  <span>Book on the go, anytime, anywhere.</span>
                </div>
                <div className="bv-app-pill__btns">
                  <Link
                    to="https://apps.apple.com/us/app/bookvenue/id6755186865"
                    target="_blank"
                    className="bv-store-btn bv-store-btn--apple"
                  >
                    <i className="fa-brands fa-apple"></i>
                    <span>
                      <em>Download on the</em>
                      App Store
                    </span>
                  </Link>
                  <Link
                    to="https://play.google.com/store/apps/details?id=com.shivamnegi.bookvenue"
                    target="_blank"
                    className="bv-store-btn bv-store-btn--google"
                  >
                    <i className="fa-brands fa-google-play"></i>
                    <span>
                      <em>Get it on</em>
                      Google Play
                    </span>
                  </Link>
                </div>
              </div>

              <div className="bv-stats-pill">
                <div className="bv-stats-pill__item bv-stats-pill__item--avatars">
                  <div className="bv-stats-pill__avatars" aria-hidden="true">
                    <LazyImage
                      src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=80&q=80&auto=format&fit=facearea&facepad=3"
                      alt=""
                    />
                    <LazyImage
                      src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&q=80&auto=format&fit=facearea&facepad=3"
                      alt=""
                    />
                    <LazyImage
                      src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&q=80&auto=format&fit=facearea&facepad=3"
                      alt=""
                    />
                  </div>
                  <div className="bv-stats-pill__txt">
                    <strong>200+</strong>
                    <span>Happy Players</span>
                  </div>
                </div>

                <span className="bv-stats-pill__divider" aria-hidden="true" />

                <div className="bv-stats-pill__item">
                  <span className="bv-stats-pill__icon bv-stats-pill__icon--star">
                    <i className="fa-solid fa-star"></i>
                  </span>
                  <div className="bv-stats-pill__txt">
                    <strong>4.8</strong>
                    <span>User Rating</span>
                  </div>
                </div>

                <span className="bv-stats-pill__divider" aria-hidden="true" />

                <div className="bv-stats-pill__item bv-stats-pill__item--reverse">
                  <div className="bv-stats-pill__txt">
                    <strong>50+</strong>
                    <span>Venues</span>
                  </div>
                  <span className="bv-stats-pill__icon bv-stats-pill__icon--venue">
                    <i className="fa-solid fa-medal"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============== EXCITING OFFERS BAR ============== */}
        <aside className="bv-offers" aria-label="Exciting offers">
          <div className="bv-offers__pill">
            <div className="bv-offers__badge">
              <span className="bv-offers__badge-icon">
                <i className="fa-solid fa-tag"></i>
              </span>
              <span className="bv-offers__badge-text">EXCITING OFFERS!</span>
            </div>

            <div className="bv-offers__track-wrap">
              <div className="bv-offers__track">
                {["a", "b"].map((k) => (
                  <div className="bv-offers__group" key={`offers-${k}`}>
                    {/* SPORTS */}
                    <div className="bv-offers__item">
                      <span className="bv-offers__item-icon">
                        <i className="fa-solid fa-user-plus"></i>
                      </span>
                      <div className="bv-offers__item-text">
                        <span>
                          Get <strong>₹20 OFF</strong>
                        </span>
                        <em>on your first registration</em>
                      </div>
                    </div>

                    <span className="bv-offers__dot" aria-hidden="true" />

                    <div className="bv-offers__item">
                      <span className="bv-offers__item-icon">
                        <i className="fa-solid fa-calendar-days"></i>
                      </span>
                      <div className="bv-offers__item-text">
                        <span>
                          Flat <strong>15% OFF</strong>
                        </span>
                        <em>on your first sports booking</em>
                      </div>
                    </div>

                    <span className="bv-offers__dot" aria-hidden="true" />

                    <div className="bv-offers__item">
                      <span className="bv-offers__item-icon">
                        <i className="fa-solid fa-percent"></i>
                      </span>
                      <div className="bv-offers__item-text">
                        <span>
                          Up to <strong>30% OFF</strong>
                        </span>
                        <em>on turf & court bookings</em>
                      </div>
                    </div>

                    <span className="bv-offers__dot" aria-hidden="true" />

                    <div className="bv-offers__item">
                      <span className="bv-offers__item-icon">
                        <i className="fa-solid fa-trophy"></i>
                      </span>
                      <div className="bv-offers__item-text">
                        <span>
                          <strong>Special Offers</strong>
                        </span>
                        <em>on tournaments & group bookings</em>
                      </div>
                    </div>

                    <span className="bv-offers__dot" aria-hidden="true" />

                    {/* HOTEL */}
                    <div className="bv-offers__item">
                      <span className="bv-offers__item-icon">
                        <i className="fa-solid fa-bed"></i>
                      </span>
                      <div className="bv-offers__item-text">
                        <span>
                          Get <strong>₹200 OFF</strong>
                        </span>
                        <em>on your first hotel stay</em>
                      </div>
                    </div>

                    <span className="bv-offers__dot" aria-hidden="true" />

                    <div className="bv-offers__item">
                      <span className="bv-offers__item-icon">
                        <i className="fa-solid fa-hotel"></i>
                      </span>
                      <div className="bv-offers__item-text">
                        <span>
                          Flat <strong>15% OFF</strong>
                        </span>
                        <em>on your first room booking</em>
                      </div>
                    </div>

                    <span className="bv-offers__dot" aria-hidden="true" />

                    <div className="bv-offers__item">
                      <span className="bv-offers__item-icon">
                        <i className="fa-solid fa-calendar-days"></i>
                      </span>
                      <div className="bv-offers__item-text">
                        <span>
                          Up to <strong>25% OFF</strong>
                        </span>
                        <em>on weekend stays</em>
                      </div>
                    </div>

                    <span className="bv-offers__dot" aria-hidden="true" />

                    <div className="bv-offers__item">
                      <span className="bv-offers__item-icon">
                        <i className="fa-solid fa-users"></i>
                      </span>
                      <div className="bv-offers__item-text">
                        <span>
                          <strong>Family Deals</strong>
                        </span>
                        <em>on selected rooms & suites</em>
                      </div>
                    </div>

                    <span className="bv-offers__dot" aria-hidden="true" />

                    <div className="bv-offers__item">
                      <span className="bv-offers__item-icon">
                        <i className="fa-solid fa-clock"></i>
                      </span>
                      <div className="bv-offers__item-text">
                        <span>
                          Save <strong>20% OFF</strong>
                        </span>
                        <em>with early hotel bookings</em>
                      </div>
                    </div>

                    <span className="bv-offers__dot" aria-hidden="true" />

                    <div className="bv-offers__item">
                      <span className="bv-offers__item-icon">
                        <i className="fa-solid fa-spa"></i>
                      </span>
                      <div className="bv-offers__item-text">
                        <span>
                          <strong>Stay & Relax</strong>
                        </span>
                        <em>exclusive amenity offers</em>
                      </div>
                    </div>

                    <span className="bv-offers__dot" aria-hidden="true" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </aside>

        {/* ============== FEATURED FACILITIES truf — magazine layout ============== */}
        <section className="bv-section bv-featured">
          <div className="bv-container bv-container--wide">
            <div className="bv-featured__head bv-reveal">
              <div className="bv-featured__head-left">
                <span className="bv-featured__eyebrow">
                  <i className="fa-solid fa-crown"></i> TOP VENUES
                </span>
                <h2 className="bv-section-title bv-featured__title">
                  Featured <span className="gradientText">Facilities</span>
                </h2>
                <p className="bv-featured__lede">
                  Discover premium sports venues with world-class facilities and
                  unforgettable experiences.
                </p>
              </div>
              <Link to="/all-facilities" className="bv-featured__view-all">
                <span>View All Venues</span>
                <i className="fa-solid fa-arrow-right"></i>
              </Link>
            </div>

            {heroFacility ? (
              <div className="bv-featured__grid">
                {/* Big hero card on the left */}
                <div className="bv-featured__hero bv-reveal bv-reveal--left">
                  <div className="bv-featured__hero-card">
                    {/* Stack of gallery images — only the active one is opaque.
                        We always render at least the featured_image fallback so the card NEVER disappears. */}
                    <div className="bv-featured__hero-imgs">
                      {(heroGallery.length > 0
                        ? heroGallery
                        : [safeImg(heroFacility, FALLBACK_HERO_CARDS[2].img)]
                      ).map((src, i) => (
                        <LazyImage
                          key={`${heroFacility?.slug || "feat"}-g${i}`}
                          src={src}
                          alt={
                            i === activeGallery
                              ? heroFacility?.official_name || "Featured"
                              : ""
                          }
                          className={`bv-featured__hero-img ${
                            i === activeGallery ? "is-active" : ""
                          }`}
                          loading={i === 0 ? "eager" : "lazy"}
                          aria-hidden={i === activeGallery ? "false" : "true"}
                        />
                      ))}
                    </div>
                    <div
                      className="bv-featured__hero-overlay"
                      aria-hidden="true"
                    />

                    <span className="bv-featured__hero-badge">
                      <i className="fa-solid fa-star"></i>
                      Most Popular
                    </span>

                    {heroGallery.length > 1 && (
                      <>
                        <button
                          type="button"
                          className="bv-featured__hero-arrow bv-featured__hero-arrow--prev"
                          onClick={() =>
                            setActiveGallery((p) =>
                              p === 0 ? heroGallery.length - 1 : p - 1,
                            )
                          }
                          aria-label="Previous venue"
                        >
                          <i className="fa-solid fa-chevron-left"></i>
                        </button>
                        <button
                          type="button"
                          className="bv-featured__hero-arrow bv-featured__hero-arrow--next"
                          onClick={() =>
                            setActiveGallery((p) =>
                              p === heroGallery.length - 1 ? 0 : p + 1,
                            )
                          }
                          aria-label="Next venue"
                        >
                          <i className="fa-solid fa-chevron-right"></i>
                        </button>
                      </>
                    )}

                    {/* Floating glass info card */}
                    <div className="bv-featured__hero-info">
                      <p className="bv-featured__hero-info-loc">
                        <i className="fa-solid fa-location-dot"></i>
                        {heroFacility?.address
                          ? heroFacility.address.slice(0, 32)
                          : "Dehradun, Uttarakhand"}
                      </p>
                      <h3 className="bv-featured__hero-info-title">
                        {heroFacility?.official_name || "BroCode Turf"}
                      </h3>
                      <p className="bv-featured__hero-info-desc">
                        {(
                          stripHtml(heroFacility?.description) ||
                          "A modern sports facility designed for players who demand the best."
                        ).slice(0, 95)}
                        …
                      </p>
                      <button
                        type="button"
                        className="bv-featured__hero-info-btn"
                        onClick={() =>
                          heroFacility?.slug &&
                          navigate(`/facility/${heroFacility.slug}`)
                        }
                      >
                        Book Now
                        <span>
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </button>
                    </div>

                    {/* Gallery thumb strip — INSIDE the card at the bottom */}
                    {heroGallery.length > 1 && (
                      <div className="bv-featured__gallery">
                        {heroGallery.map((src, i) => (
                          <button
                            key={`gthumb-${heroFacility?.slug || "g"}-${i}`}
                            type="button"
                            className={`bv-featured__gallery-thumb ${
                              i === activeGallery ? "is-active" : ""
                            }`}
                            onClick={() => setActiveGallery(i)}
                            aria-label={`Gallery image ${i + 1}`}
                          >
                            <LazyImage src={src} alt="" />
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Right side mini cards */}
                <div className="bv-featured__side bv-reveal bv-reveal--right">
                  {sideCards.length === 0 && (
                    <div className="bv-featured__empty">
                      More venues coming soon
                    </div>
                  )}
                  {sideCards.map((f, i) => {
                    const desc = stripHtml(f?.description);
                    const isActive = i === activeFeat;
                    const primaryName = f?.services?.[0]?.name || "Sport";
                    const cornerIcon = (() => {
                      const n = primaryName.toLowerCase();
                      if (/foot|soccer|turf/.test(n))
                        return "fa-solid fa-futbol";
                      if (/cricket|bat/.test(n))
                        return "fa-solid fa-baseball-bat-ball";
                      if (/badm|shuttle|racquet|racket/.test(n))
                        return "fa-solid fa-table-tennis-paddle-ball";
                      if (/basket/.test(n)) return "fa-solid fa-basketball";
                      if (/tennis/.test(n)) return "fa-solid fa-baseball";
                      if (/volley/.test(n)) return "fa-solid fa-volleyball";
                      return "fa-solid fa-trophy";
                    })();
                    const tagImgs = [
                      SPORT_IMG_BY_NAME(primaryName),
                      SPORT_IMG_BY_NAME(f?.services?.[1]?.name || "Court"),
                      SPORT_IMG_BY_NAME(f?.services?.[2]?.name || "Parking"),
                    ];
                    const tagLabels = [
                      primaryName,
                      f?.services?.[1]?.name || "Indoor",
                      f?.services?.[2]?.name || "Parking",
                    ];
                    return (
                      <article
                        key={f?.slug || `side-${i}`}
                        className={`bv-featured__mini ${isActive ? "is-active" : ""}`}
                      >
                        <button
                          type="button"
                          className="bv-featured__mini-overlay"
                          aria-label={`Show ${f?.official_name || "venue"} in spotlight`}
                          onClick={() => setActiveFeat(i)}
                        />
                        <div className="bv-featured__mini-media">
                          <LazyImage
                            src={safeImg(f, FALLBACK_HERO_CARDS[i].img)}
                            alt={f?.official_name || ""}
                          />
                          <span className="bv-featured__mini-icon">
                            <i className={cornerIcon}></i>
                          </span>
                        </div>
                        <div className="bv-featured__mini-body">
                          <h3>{f?.official_name}</h3>
                          <p className="bv-featured__mini-loc">
                            <i className="fa-solid fa-location-dot"></i>
                            {f?.address ? f.address.slice(0, 32) : "—"}…
                          </p>
                          <p className="bv-featured__mini-desc">
                            {(
                              desc ||
                              "State-of-the-art facility offering indoor and outdoor sports."
                            ).slice(0, 60)}
                            …
                          </p>
                          <div className="bv-featured__mini-tags">
                            {tagLabels.map((label, k) => (
                              <span key={`${label}-${k}`}>
                                <span className="bv-featured__mini-tag-icon">
                                  <LazyImage src={tagImgs[k]} alt="" />
                                </span>
                                {label}
                              </span>
                            ))}
                          </div>
                        </div>
                        <Link
                          to={
                            f?.slug ? `/facility/${f.slug}` : "/all-facilities"
                          }
                          className="bv-featured__mini-arrow"
                          aria-label={`Open ${f?.official_name || "venue"}`}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <i className="fa-solid fa-arrow-right"></i>
                        </Link>
                      </article>
                    );
                  })}
                </div>
              </div>
            ) : (
              <p className="bv-featured__empty bv-reveal">
                No featured venues to show right now.
              </p>
            )}
          </div>
        </section>

        {/* ============== FEATURED FACILITIES hotels — magazine layout ============== */}
        <section className="bv-section bv-featured bv-featured--hotels">
          <div className="bv-container bv-container--wide">
            <div className="bv-featured__head bv-reveal">
              <div className="bv-featured__head-left">
                <span className="bv-featured__eyebrow">
                  <i className="fa-solid fa-crown"></i> TOP HOTELS
                </span>

                <h2 className="bv-section-title bv-featured__title">
                  Featured <span className="gradientText">Hotels</span>
                </h2>

                <p className="bv-featured__lede">
                  Discover comfortable stays, premium hotels and resorts across
                  Dehradun.
                </p>
              </div>

              <Link to="/hotels" className="bv-featured__view-all">
                <span>View All Hotels</span>
                <i className="fa-solid fa-arrow-right"></i>
              </Link>
            </div>

            {hotelsLoading ? (
              <div className="bv-featured__grid">
                <div className="bv-featured__hero bv-reveal">
                  <div className="bv-featured__hero-card">
                    <div
                      style={{
                        height: "100%",
                        minHeight: "500px",
                        borderRadius: "28px",
                        background: "#e8e2d9",
                      }}
                    />
                  </div>
                </div>

                <div className="bv-featured__side">
                  {[1, 2, 3].map((item) => (
                    <article
                      key={item}
                      className="bv-featured__mini"
                      style={{
                        background: "#eee8df",
                        minHeight: "150px",
                      }}
                    />
                  ))}
                </div>
              </div>
            ) : allHotels.length > 0 ? (
              <div className="bv-featured__grid">
                {/* ================= BIG HOTEL ================= */}
                <div className="bv-featured__hero bv-reveal bv-reveal--left">
                  {(() => {
                    const hotel = allHotels[activeHotel];

                    const image = getHotelImage(hotel);
                    const hotelImages = getHotelGallery(hotel);

                    const images =
                      hotelImages.length > 0 ? hotelImages : [image];

                    const slug = getHotelSlug(hotel);

                    const name =
                      hotel?.name ||
                      hotel?.hotel_name ||
                      hotel?.hotelName ||
                      hotel?.title ||
                      "Featured Hotel";

                    const address =
                      hotel?.address ||
                      hotel?.location ||
                      hotel?.full_address ||
                      hotel?.fullAddress ||
                      "Dehradun, Uttarakhand";

                    const description =
                      hotel?.description ||
                      hotel?.short_description ||
                      hotel?.shortDescription ||
                      hotel?.about ||
                      "Enjoy a comfortable stay with premium facilities and excellent hospitality.";

                    const price = getHotelPrice(hotel);
                    const rating = getHotelRating(hotel);

                    return (
                      <div className="bv-featured__hero-card">
                        {/* HOTEL IMAGE SLIDER */}
                        <div className="bv-featured__hero-imgs">
                          {images.map((src, i) => (
                            <LazyImage
                              key={`${slug || "hotel"}-img-${i}`}
                              src={src}
                              alt={i === activeHotelImage ? name : ""}
                              className={`bv-featured__hero-img ${
                                i === activeHotelImage ? "is-active" : ""
                              }`}
                              loading={i === 0 ? "eager" : "lazy"}
                              aria-hidden={
                                i === activeHotelImage ? "false" : "true"
                              }
                            />
                          ))}
                        </div>

                        <div
                          className="bv-featured__hero-overlay"
                          aria-hidden="true"
                        />

                        {/* HOTEL IMAGE PREVIOUS */}
                        {images.length > 1 && (
                          <>
                            <button
                              type="button"
                              className="bv-featured__hero-arrow bv-featured__hero-arrow--prev"
                              onClick={() =>
                                setActiveHotelImage((prev) =>
                                  prev === 0 ? images.length - 1 : prev - 1,
                                )
                              }
                              aria-label="Previous hotel image"
                            >
                              <i className="fa-solid fa-chevron-left"></i>
                            </button>

                            {/* HOTEL IMAGE NEXT */}
                            <button
                              type="button"
                              className="bv-featured__hero-arrow bv-featured__hero-arrow--next"
                              onClick={() =>
                                setActiveHotelImage((prev) =>
                                  prev === images.length - 1 ? 0 : prev + 1,
                                )
                              }
                              aria-label="Next hotel image"
                            >
                              <i className="fa-solid fa-chevron-right"></i>
                            </button>
                          </>
                        )}

                        <span className="bv-featured__hero-badge">
                          <i className="fa-solid fa-star"></i>
                          Featured Hotel
                        </span>

                        {/* HOTEL INFO */}
                        <div className="bv-featured__hero-info">
                          <p className="bv-featured__hero-info-loc">
                            <i className="fa-solid fa-location-dot"></i>
                            {address.slice(0, 40)}
                          </p>

                          <h3 className="bv-featured__hero-info-title">
                            {name}
                          </h3>

                          <p className="bv-featured__hero-info-desc">
                            {stripHtml(description).slice(0, 100)}
                            {stripHtml(description).length > 100 ? "…" : ""}
                          </p>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "14px",
                              marginBottom: "14px",
                            }}
                          >
                            {price !== null && (
                              <strong style={{ color: "#0F172A" }}>
                                ₹{price.toLocaleString("en-IN")}
                                <small style={{ fontWeight: 400 }}>
                                  {" "}
                                  / night
                                </small>
                              </strong>
                            )}

                            {rating !== null && (
                              <span
                                style={{
                                  color: "#fff",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <i
                                  className="fa-solid fa-star"
                                  style={{ color: "#fbbf24" }}
                                />
                                {rating}
                              </span>
                            )}
                          </div>

                          <button
                            type="button"
                            className="bv-featured__hero-info-btn"
                            onClick={() => slug && navigate(`/hotels/${slug}`)}
                          >
                            Book Now
                            <span>
                              <i className="fa-solid fa-arrow-right"></i>
                            </span>
                          </button>
                        </div>

                        {/* HOTEL THUMBNAIL SLIDER */}
                        {images.length > 1 && (
                          <div className="bv-featured__gallery">
                            {images.map((src, i) => (
                              <button
                                key={`hotel-thumb-${slug || "hotel"}-${i}`}
                                type="button"
                                className={`bv-featured__gallery-thumb ${
                                  i === activeHotelImage ? "is-active" : ""
                                }`}
                                onClick={() => setActiveHotelImage(i)}
                                aria-label={`Hotel gallery image ${i + 1}`}
                              >
                                <LazyImage src={src} alt="" />
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>

                {/* ================= SMALL HOTELS ================= */}
                <div className="bv-featured__side bv-reveal bv-reveal--right">
                  {allHotels.slice(0, 5).map((hotel, index) => {
                    const image = getHotelImage(hotel);
                    const slug = getHotelSlug(hotel);

                    const name =
                      hotel?.name ||
                      hotel?.hotel_name ||
                      hotel?.hotelName ||
                      hotel?.title ||
                      "Hotel";

                    const address =
                      hotel?.address ||
                      hotel?.location ||
                      hotel?.full_address ||
                      hotel?.fullAddress ||
                      "Dehradun";

                    const description =
                      hotel?.description ||
                      hotel?.short_description ||
                      hotel?.shortDescription ||
                      hotel?.about ||
                      "Comfortable stay with excellent facilities.";

                    const price = getHotelPrice(hotel);
                    const rating = getHotelRating(hotel);

                    const tags = getHotelTags(hotel);

                    return (
                      <article
                        key={slug || `hotel-${index}`}
                        className={`bv-featured__mini ${index === activeHotel ? "is-active" : ""}`}
                      >
                        <button
                          type="button"
                          className="bv-featured__mini-overlay"
                          aria-label={`Show ${name}`}
                          onClick={() => setActiveHotel(index)}
                        />

                        <div className="bv-featured__mini-media">
                          <LazyImage src={image} alt={name} />
                          <span className="bv-featured__mini-icon">
                            <i className="fa-solid fa-hotel"></i>
                          </span>
                        </div>

                        <div className="bv-featured__mini-body">
                          <h3>{name}</h3>

                          <p className="bv-featured__mini-loc">
                            <i className="fa-solid fa-location-dot"></i>
                            {address.slice(0, 35)}
                          </p>

                          <p className="bv-featured__mini-desc">
                            {stripHtml(description).slice(0, 65)}…
                          </p>

                          {/* DESKTOP tags */}
                          <div className="bv-featured__mini-tags">
                            {tags.length > 0 ? (
                              tags.slice(0, 3).map((tag, i) => (
                                <span key={`${tag}-${i}`}>
                                  <span className="bv-featured__mini-tag-icon">
                                    <i className="fa-solid fa-check"></i>
                                  </span>
                                  {tag}
                                </span>
                              ))
                            ) : (
                              <>
                                <span>
                                  <span className="bv-featured__mini-tag-icon">
                                    <i className="fa-solid fa-bed"></i>
                                  </span>
                                  Stay
                                </span>
                                <span>
                                  <span className="bv-featured__mini-tag-icon">
                                    <i className="fa-solid fa-wifi"></i>
                                  </span>
                                  WiFi
                                </span>
                                {rating !== null && (
                                  <span>
                                    <span className="bv-featured__mini-tag-icon">
                                      <i className="fa-solid fa-star"></i>
                                    </span>
                                    {rating}
                                  </span>
                                )}
                              </>
                            )}
                          </div>

                          {/* MOBILE ONLY: Stay → Price → Arrow */}
                          <div className="bv-featured__mini-mobile">
                            <span className="bv-featured__mini-stay">
                              <i className="fa-solid fa-bed"></i>
                              Stay
                            </span>

                            {price !== null && (
                              <span className="bv-featured__mini-mprice">
                                ₹{price.toLocaleString("en-IN")}
                                <small>/night</small>
                              </span>
                            )}

                            <button
                              type="button"
                              className="bv-featured__mini-go"
                              aria-label={`View ${name}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (slug) navigate(`/hotels/${slug}`);
                              }}
                            >
                              <i className="fa-solid fa-arrow-right"></i>
                            </button>
                          </div>
                        </div>

                        {/* DESKTOP arrow */}
                        <button
                          type="button"
                          className="bv-featured__mini-arrow"
                          aria-label={`View ${name}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (slug) navigate(`/hotels/${slug}`);
                          }}
                        >
                          <i className="fa-solid fa-arrow-right"></i>
                        </button>

                        {/* DESKTOP price */}
                        {price !== null && (
                          <span className="bv-featured__mini-price-abs">
                            ₹{price.toLocaleString("en-IN")}/night
                          </span>
                        )}
                      </article>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="bv-featured__empty bv-reveal">
                <p>No hotels available right now.</p>

                <Link to="/hotels" className="bv-btn bv-btn--primary">
                  View All Hotels
                </Link>
              </div>
            )}
          </div>
        </section>

        {/* ============== FAQ — Modern split ============== */}
        <section className="bv-section bv-section--faq">
          <div className="bv-container bv-container--wide">
            <div className="bv-faq-wrap">
              <aside className="bv-faq-aside bv-reveal bv-reveal--left">
                <span className="bv-section-eyebrow">
                  <i className="fa-solid fa-circle-question"></i> Got Questions?
                </span>
                <h2 className="bv-section-title bv-faq-aside__title">
                  Frequently Asked{" "}
                  <span className="gradientText">Questions</span>
                </h2>
                <p className="bv-faq-aside__lede">
                  Everything you need to know about booking hotels, stays,
                  sports venues, payments, cancellations, and more on BookVenue
                  — answered
                </p>
                <Link
                  to="/contact"
                  className="bv-btn bv-btn--ghost bv-faq-aside__btn"
                >
                  <i className="fa-solid fa-headset"></i>
                  Still need help?
                </Link>
              </aside>

              <div className="bv-faq-list bv-reveal bv-reveal--right">
                {[
                  {
                    q: "How can I book a hotel or sports venue at BookVenue?",
                    a: "Search for your preferred hotel, resort, or sports venue, select your desired date and time, check availability, and complete your booking securely. Your booking details are confirmed instantly.",
                  },
                  {
                    q: "How long can I book a hotel or sports venue?",
                    a: "Booking duration depends on the property or venue. Hotels can be booked by the night or according to the available stay options, while sports facilities may offer hourly or time-slot bookings. Check the listing for the available options.",
                  },
                  {
                    q: "Can I cancel or reschedule my hotel or sports booking after confirmation?",
                    a: "Yes, cancellation and rescheduling options depend on the property's or venue's policy. Check the booking details for the applicable cancellation terms, deadlines, and refund information before making a change.",
                  },
                  {
                    q: "Does BookVenue offer memberships, packages, or special deals?",
                    a: "Yes. Depending on the hotel or sports venue, you may find memberships, stay packages, coaching programs, seasonal offers, and exclusive discounts. Check the property or venue page for available offers and details.",
                  },
                  {
                    q: "How can I check availability before booking?",
                    a: "BookVenue shows real-time availability for hotels, rooms, sports venues, and available time slots. Simply select your preferred date and time to see what's available before you book.",
                  },
                ].map((it, i) => {
                  const idx = i + 1;
                  const open = openIndex === idx;
                  return (
                    <article
                      key={it.q}
                      className={`bv-faq-item ${open ? "is-open" : ""}`}
                    >
                      <button
                        type="button"
                        className="bv-faq-item__btn"
                        aria-expanded={open}
                        onClick={() => toggleAccordion(idx)}
                      >
                        <span className="bv-faq-item__num">
                          {String(idx).padStart(2, "0")}
                        </span>
                        <span className="bv-faq-item__q">{it.q}</span>
                        <span className="bv-faq-item__chev">
                          <i className="fa-solid fa-chevron-down"></i>
                        </span>
                      </button>
                      <div className="bv-faq-item__body">
                        <div className="bv-faq-item__body-inner">{it.a}</div>
                      </div>
                    </article>
                  );
                })}
              </div>
            </div>
          </div>
        </section>

        {/* Hidden helpers — keep refs to other state to avoid lint flags */}
        <div style={{ display: "none" }} aria-hidden="true">
          {allServices?.length || 0} services · {allFacilities?.length || 0}{" "}
          nearby
        </div>
      </Default>
    </>
  );
};

export default Homepage;
